import { useCallback, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader, Loading, ErrorState, EmptyState } from "@/components/Bits";
import { inputCls, Table, Td } from "@/components/Kit";
import { NoAccess } from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";

export default function LabReports() {
  const { can } = useAuth();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const load = useCallback(async () => {
    setD(null);
    try { const { data } = await api.get("/lab/reports", { params: { from_date: from || undefined, to_date: to || undefined } }); setD(data); }
    catch (e) { setError(apiError(e)); }
  }, [from, to]);
  useEffect(() => { load(); }, [load]);

  if (!can("lab.reports.view")) return <NoAccess what="Lab reports" />;

  return (
    <div data-testid="lab-reports-page">
      <PageHeader overline="Laboratory" title="Lab Reports"
        subtitle="Revenue, collections, outstanding dues and test-wise performance across the lab." />
      <div className="flex flex-wrap gap-3 mb-6">
        <input type="date" className={`${inputCls} max-w-[170px]`} value={from} onChange={(e) => setFrom(e.target.value)} data-testid="lab-report-from" />
        <input type="date" className={`${inputCls} max-w-[170px]`} value={to} onChange={(e) => setTo(e.target.value)} data-testid="lab-report-to" />
      </div>
      {error && <ErrorState message={error} />}
      {!d ? <Loading /> : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            {[["Orders", d.orders], ["Billed (₹)", d.total_billed], ["Collected (₹)", d.total_collected],
              ["Due (₹)", d.total_due], ["In-house (₹)", d.internal_billed], ["Partner (₹)", d.partner_billed]].map(([l, v]) => (
              <div key={l} className="panel p-4" data-testid={`lab-report-stat-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <p className="text-xs text-slate-400">{l}</p><p className="text-xl font-semibold text-slate-900">{typeof v === "number" ? v.toLocaleString("en-IN") : v}</p>
              </div>
            ))}
          </div>
          <p className="overline text-[#EA580C] mb-3">Test-wise performance</p>
          <Table testid="lab-report-by-test" columns={["Test", "Count", "Revenue (₹)"]}
            rows={d.by_test} empty={<EmptyState title="No data in range" testid="lab-report-empty" />}
            renderRow={(r) => (
              <tr key={r.name}><Td className="font-medium text-slate-900">{r.name}</Td><Td>{r.count}</Td><Td>₹{r.revenue.toLocaleString("en-IN")}</Td></tr>
            )} />
        </>
      )}
    </div>
  );
}
